import React from 'react';

import useEventSettingsForm, { EventFormProps } from '../useEventSettingsForm';

import EventActiveControl from '../controls/EventActiveControl';
import EventLevelControl from '../controls/EventLevelControl';
import EventTimeIntervalControl from '../controls/EventTimeIntervalControl';
import EventFormControls from '../controls/EventFormControls';
import { RouteLeavingGuard } from '../../../../../components/RouteLeavingGuard';
import { Panel } from '../../../../../components/Panel';
import { t } from '../../../../../lib/i18n';
import { getLabelForEventType } from '../../../../../lib/getLabelForEventType';

export default function HeatDetectorFireEventForm(props: EventFormProps) {
  const form = useEventSettingsForm({
    sensorType: 'climax_heat_detector',
    eventType: 'fire',

    initialValues: props.initialValues,
  });

  return (
    <form onSubmit={form.handleSubmit}>
      <RouteLeavingGuard when={form.dirty} />
      <h2>{getLabelForEventType('fire', 'climax_heat_detector')}</h2>

      <Panel>
        <span
          dangerouslySetInnerHTML={{
            __html: t(
              'manage.sensors.events.HeatDetectorFireEventForm.firstInfo'
            ),
          }}
        />
      </Panel>

      <EventActiveControl form={form} />

      <EventTimeIntervalControl form={form} />

      <EventLevelControl form={form} />

      <EventFormControls form={form} />
    </form>
  );
}
